<div class="btn-group" role="group">
  <button type="button" class="btn" [ngClass]="generateClass('process')" (click)="getProcesses()">
    <i class="fa fa-tasks"></i> Prozess
  </button>
  <button type="button" class="btn" [ngClass]="generateClass('archive')" (click)="getCategories()">
    <i class="fa fa-archive"></i> Archiv
  </button>
</div>

@if (typ === 'archive') {
  <div>
    <div class="content-box">
      @for (category of categories; track trackByFn($index, category)) {
        <div class="content-box-table-row">
          <div class="content-box-cell content-box-category">
            @if (!category.base_name) {
              <span class="base">{{ category.name }}</span>
            }
            @if (category.base_name) {
              <span class="sub">
                <span class="basename">{{ category.base_name }} / </span>{{ category.name }}
              </span>
            }
          </div>
          <div class="content-box-cell content-box-cell-action">
            @if (!isSelected(category)) {
              <a (click)="add(category)" class="click">
                <i class="fa fa-toggle-off"></i>
              </a>
            }
            @if (isSelected(category)) {
              <a (click)="remove(category)" class="click">
                <i class="fa fa-toggle-on"></i>
              </a>
            }
          </div>
        </div>
      }
    </div>
    <div style="clear: both;">&nbsp;</div>
    @if (selected.size > 0) {
      <button type="button" class="btn btn-success btn-lg pull-right next-button"
        (click)="next(null)"
        [disabled]="blocked">
        Weiter
      </button>
    }
  </div>
}

@if (typ === 'process') {
  <div>
    <div class="content-box">
      @for (category of categories; track trackByFn($index, category)) {
        <div class="content-box-table-row">
          <div class="content-box-cell content-box-category">
            @if (!category.base_name) {
              <span class="sub subprocess">{{ category.name }}</span>
            }
            @if (category.base_name) {
              <span class="sub subprocess">
                <span class="basename">{{ category.base_name }} / </span>{{ category.name }}
              </span>
            }
          </div>
          <div class="content-box-cell content-box-cell-action">
            <a class="click" (click)="next(category)">
              <i class="fa fa-angle-right"></i>
            </a>
          </div>
        </div>
      }
    </div>
  </div>
}
